





















































































import { Component, Prop, Vue } from "vue-property-decorator";

import JConfTableV01 from "@share/common/tables/j-conf-table/virtual/JConfTable-V01.vue";
import TableArrows from "@share/common/table-arrows/TableArrows.vue";
import TicketStatusIcon from "@share/committees/common/components/TicketStatusIcon.vue";

import { dateToFormatFromIso } from "@common/dateTimeHelper";
import { HeaderSetting, TableClasses, TableSettings } from "@share/common/tables/j-conf-table/types";
import { UserProfile } from "@api/models/UserProfile";
import { TicketRowInterfaceView } from "@share/committees/common/types/interfaces/TicketsRowInterface";

@Component({ components: { JConfTableV01, TableArrows, TicketStatusIcon } })

export default class S2Tickets extends Vue {

    @Prop({ default: () => [] }) list: TicketRowInterfaceView[];
    @Prop() userProfiles: Record<string, UserProfile>;
    @Prop() isLoading: boolean;

    tableSettings: TableSettings = {minRowHeight: 76};

    tableClasses: TableClasses = {
        header: 's-2-tickets__table-header',
        row: 's-2-tickets__table-row'
    }

    openTicket(ticket: TicketRowInterfaceView) {
        this.$emit('open', ticket);
    }

    toTicketEdit(ticket: TicketRowInterfaceView) {
        this.$emit('edit', ticket);
    }

    getFormatedDate(dateString: string) {
        return dateToFormatFromIso(dateString, "dd.LL.yyyy");
    }

    get headerSettings(): HeaderSetting[] {
        return [
            {
                title: this.$t('agenda.form.titles.name').toString(),
                name: "title"
            },
            {
                title: this.$t("tickets.columns.category").toString(),
                name: 'category'
            },
            {   title: this.$t("tickets.columns.status").toString(),
                name: "status"
            },
            {   title: this.$t("tickets.columns.company").toString(),
                name: "company"
            },
            {   title: this.$t("tickets.columns.dateOfSubmission").toString(),
                name: "createdAt"
            },
            {   title: this.$t("tickets.columns.implementationDate").toString(),
                name: "implementedAt"
            },
            {
                title: "",
                name: "edit"
            }
        ]
    }

    get userId() {
        return this.$store.getters['userId'];
    }

    canEdit(row: TicketRowInterfaceView) {
        return row.responsibleUserId === this.userId || row.responsibleForImplementationUserId === this.userId;
    }
}

